module.exports = __webpack_public_path__ + "static/media/ilbc3.9b1b7d55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ilbc3.jpg
// module id = 5801
// module chunks = 0